import React from 'react';
import './AuthLayout.css';

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-layout">
      {/* Left Container - Form */}
      <div className="auth-left">
        <div className="auth-form-container">
          {children}
        </div>
      </div>

      {/* Right Container - Illustration */}
      <div className="auth-right">
        <div className="auth-illustration">
          {/* Background Image */}
          <div className="background-image">
            <img 
              src="/img/background.png" 
              alt="Background" 
              className="bg-image"
              onError={(e) => {
                console.error('Failed to load background.png');
                e.target.style.display = 'none';
              }}
            />
          </div>

          {/* Background gradient and blur effect */}
          <div className="illustration-background">
            {/* Decorative elements */}
            <div className="decorative-shapes">
              {/* Floating decorative elements matching Figma */}
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
              <div className="shape shape-4"></div>
              <div className="shape shape-5"></div>
              <div className="shape shape-6"></div>
              
              {/* Additional geometric shapes */}
              <div className="geometric-shape rect-1"></div>
              <div className="geometric-shape rect-2"></div>
              <div className="geometric-shape circle-1"></div>
              <div className="geometric-shape circle-2"></div>
              <div className="geometric-shape square-1"></div>
              <div className="geometric-shape square-2"></div>
            </div>

            {/* Main content container */}
            <div className="illustration-content">
              <div className="content-wrapper">
                {/* Title and description */}
                <div className="illustration-text">
                  <h1 className="illustration-title">
                    The AI-Powered EHR<br />
                    for Smarter Psychological Assessments
                  </h1>
                  <div className="feature-list">
                    <div className="feature-item">
                      • Instant, Accurate, and Minimal-Edit Assessment Reports
                    </div>
                    <div className="feature-item">
                      • AI-Driven Insights & Personalized Recommendations
                    </div>
                    <div className="feature-item">
                      • Fully Customizable Workflows and Smart Communication Tools
                    </div>
                  </div>
                </div>

                {/* Upper Background Image */}
                <div className="upper-bg-container">
                  <img 
                    src="/img/upper_bg.png" 
                    alt="Dashboard Illustration" 
                    className="upper-bg-image"
                    onError={(e) => {
                      console.error('Failed to load upper_bg.png');
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
